import React from 'react';

function ToJsonFormatter({entity}) {
    return <pre>{JSON.stringify(entity, null, 4)}</pre>;
}

export default ToJsonFormatter;
